export default {
    recruitmentDepthChart(state) {
        return state.recruitmentDepthChart;
    },
    error(state) {
        return state.error;
    }
};
